import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { initAuth } from './utils/auth'

// Initialize authentication
initAuth()

// Create Telegram WebApp instance if available
const tg = window.Telegram?.WebApp

// Initialize Telegram WebApp if available
if (tg) {
  console.log('Telegram WebApp is available, initializing...')
  
  // Expand to fullscreen mode
  tg.expand()
  
  // Notify Telegram that the Mini App is ready
  tg.ready()
  
  // Set app theme based on Telegram theme
  document.documentElement.style.setProperty('--tg-theme-bg-color', tg.themeParams.bg_color || '#ffffff')
  document.documentElement.style.setProperty('--tg-theme-text-color', tg.themeParams.text_color || '#000000')
  document.documentElement.style.setProperty('--tg-theme-hint-color', tg.themeParams.hint_color || '#999999')
  document.documentElement.style.setProperty('--tg-theme-link-color', tg.themeParams.link_color || '#2481cc')
  document.documentElement.style.setProperty('--tg-theme-button-color', tg.themeParams.button_color || '#2481cc')
  document.documentElement.style.setProperty('--tg-theme-button-text-color', tg.themeParams.button_text_color || '#ffffff')
} else {
  console.warn('Telegram WebApp is not available, running in standalone mode')
  
  // Set default theme colors for standalone mode
  document.documentElement.style.setProperty('--tg-theme-bg-color', '#ffffff')
  document.documentElement.style.setProperty('--tg-theme-text-color', '#000000')
  document.documentElement.style.setProperty('--tg-theme-hint-color', '#999999')
  document.documentElement.style.setProperty('--tg-theme-link-color', '#2481cc')
  document.documentElement.style.setProperty('--tg-theme-button-color', '#2481cc')
  document.documentElement.style.setProperty('--tg-theme-button-text-color', '#ffffff')
}

// Create Vue app
const app = createApp(App)

// Add Telegram WebApp to global properties if available
if (tg) {
  app.config.globalProperties.$tg = tg
}

// Use router and store
app.use(router)
app.use(store)

// Mount app
app.mount('#app') 